import React, { useCallback, useEffect, useState } from 'react'
import { connect } from 'react-redux'

import {
  doFetchJiraCloudIssueSearch,
  selectCreateIssueTypeFieldsFieldMeta,
} from 'ducks/integrations/jiraCloud'
import {
  selectJiraSearchedIssuesAsOptions,
  selectJiraSearchIssuesAreLoading,
  selectJiraTypes,
} from 'ducks/integrations/jiraShared'
import ValidatedField from 'shared/components/ui/ValidatedField'
import { Label } from 'shared/ui'
import { Dropdown } from 'util/ui'
import { debounce } from 'util/functions'
import { PARENT } from 'ducks/integrations/jiraCloud/createIssueTypeFieldKeys'

import FormRow from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/FormRow'
import ProjectLabel from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/ProjectLabel'
import OptionalLabel from 'components/App/DesktopView/Layout/RightSidebar/InAppCards/shared/LinkResource/OptionalLabel'

export default connect(
  (
    state,
    {
      projectId,
      siteId,
      formFields: { type: issueTypeId, project: issueTypeProjectId },
    }
  ) => {
    return {
      areIssuesLoading: selectJiraSearchIssuesAreLoading(state, {
        source: 'jiraCloud',
      }),
      issues: selectJiraSearchedIssuesAsOptions(state, { source: 'jiraCloud' }),
      types: selectJiraTypes(state, {
        projectId,
        siteId,
        source: 'jiraCloud',
      }),
      fieldMeta: selectCreateIssueTypeFieldsFieldMeta(state, {
        projectId: issueTypeProjectId,
        issueTypeId,
        fieldKey: PARENT,
      }),
    }
  },
  {
    fetchJiraCloudIssueSearch: doFetchJiraCloudIssueSearch,
  }
)(ParentIssueFormField)
function dontFilter(results) {
  return results
}

function ParentIssueFormField({
  areIssuesLoading,
  fetchJiraCloudIssueSearch,
  formFields: { parent = null, type = null } = {},
  issues,
  onChange,
  projectId,
  resetFields,
  siteId,
  types,
  fieldMeta,
}) {
  const [currentSearchQuery, setSearchQuery] = useState('')
  useEffect(
    () => {
      resetFields('parent')
      setSearchQuery('')
      fetchJiraCloudIssueSearch(siteId, '', projectId, true)
    },
    [fetchJiraCloudIssueSearch, projectId, resetFields, setSearchQuery, siteId]
  )
  const onSearchChange = useCallback(
    (event, { searchQuery }) => {
      setSearchQuery(searchQuery)
      fetchJiraCloudIssueSearch(siteId, searchQuery, projectId, true)
    },
    [fetchJiraCloudIssueSearch, projectId, setSearchQuery, siteId]
  )
  let noResultsMessage = 'Search for Jira Cloud Issues.'
  if (areIssuesLoading) noResultsMessage = 'Loading...'
  if (!areIssuesLoading && currentSearchQuery.length > 0)
    noResultsMessage = 'No results found.'
  const isTypeChoosen = !!type
  const isTypeSubtask =
    types &&
    !!types.find(({ id, subtask }) => {
      return id === type && subtask
    })
  if (!(isTypeChoosen && isTypeSubtask)) return null
  // this field is not supported on JIRA for the project + issue type combo
  if (!fieldMeta) return null
  return (
    <FormRow>
      <Label as="div">
        Parent Issue&nbsp;
        {!fieldMeta.required && <OptionalLabel>(optional)</OptionalLabel>}
      </Label>
      <ValidatedField
        fluid
        loading={areIssuesLoading}
        name="parent"
        noResultsMessage={noResultsMessage}
        options={
          issues &&
          issues.map(option => ({
            ...option,
            children: (
              <React.Fragment key={option.value}>
                <div>
                  <strong>{option.text}</strong>
                </div>
                <ProjectLabel>{option.project}</ProjectLabel>
                {option.components.length > 0 && (
                  <div>{option.components.join(', ')}</div>
                )}
              </React.Fragment>
            ),
          }))
        }
        onChange={onChange}
        onSearchChange={debounce(onSearchChange, 500)}
        placeholder={noResultsMessage}
        search={dontFilter}
        selection
        selectOnNavigation={false}
        validatedFieldComponent={Dropdown}
        value={parent}
      />
    </FormRow>
  )
}
